import { createAction } from 'redux-act';
// add Client action
const addClientRequest = createAction('ADD_CLIENT_REQUEST', data => data);
const addClientSuccess = createAction('ADD_CLIENT_SUCCESS', data => data);
const addClientError = createAction('ADD_CLIENT_ERROR');

// get Client action
const getAllClientRequest = createAction('GET_ALL_CLIENT_REQUEST', data => data);
const getAllClientSuccess = createAction('GET_ALL_CLIENT_SUCCESS', data => data);
const getAllClientError = createAction('GET_ALL_CLIENT_ERROR');

// get Client list
const getClientListRequest = createAction('GET_CLIENT_LIST_REQUEST', data => data);
const getClientListSuccess = createAction('GET_CLIENT_LIST_SUCCESS', data => data);
const getClientListError = createAction('GET_CLIENT_LIST_ERROR');


// Update Client action
const updateClientRequest = createAction('Update_CLIENT_REQUEST', data => data);
const updateClientSuccess = createAction('Update_CLIENT_SUCCESS', data => data);
const updateClientError = createAction('Update_CLIENT_ERROR');

// Delete Client action
const deleteClientRequest = createAction('Delete_CLIENT_REQUEST', data => data);
const deleteClientSuccess = createAction('Delete_CLIENT_SUCCESS', data => data);
const deleteClientError = createAction('Delete_CLIENT_ERROR');

// Get Client details action
const getClientDetailRequest = createAction('GET_CLIENT_DETAILS_REQUEST', data => data);
const getClientDetailSuccess = createAction('GET_CLIENT_DETAILS_SUCCESS', data => data);
const getClientDetailError = createAction('GET_CLIENT_DETAILS_ERROR');

// Get Client details action
const updateClientDetailsRequest = createAction('UPDATE_CLIENT_DETAILS_REQUEST', data => data);
const updateClientDetailsSuccess = createAction('UPDATE_CLIENT_DETAILS_SUCCESS', data => data);
const updateClientDetailsError = createAction('UPDATE_CLIENT_DETAILS_ERROR');

// clear existing Client action
const handleClearClientStore = createAction('HANDLE_CLEAR_CLIENT_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addClientRequest,
    addClientSuccess,
    addClientError,

    getAllClientRequest,
    getAllClientSuccess,
    getAllClientError,

    getClientListRequest,
    getClientListSuccess,
    getClientListError,

    updateClientRequest,
    updateClientSuccess,
    updateClientError,

    deleteClientRequest,
    deleteClientSuccess,
    deleteClientError,

    getClientDetailRequest,
    getClientDetailSuccess,
    getClientDetailError,

    updateClientDetailsRequest,
    updateClientDetailsSuccess,
    updateClientDetailsError,

    handleClearClientStore,
    // toastMsgAction,
    
}